import React from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
}
const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
}: Props) => {
  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
      <div className='bg-white rounded-lg shadow-lg p-6 w-full max-w-md mx-4'>
        <h3 className='text-lg font-semibold text-gray-800 mb-2'>{title}</h3>
        <p className='text-gray-600 mb-6'>{message}</p>

        <div className='flex justify-end gap-3'>
          <button
            onClick={onClose}
            className='px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded transition-colors'
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className='px-4 py-2 bg-primary hover:bg-opacity-90 text-white rounded transition-colors'
          >
            Yes, Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
